(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );


  const enhanceKyronClubMenu = (root = document) => {
    const targetLabel = 'clube kyron';
    const links = root.querySelectorAll('.section-header nav a, .section-header .menu-drawer a');

    links.forEach((link) => {
      const linkLabel = link.textContent.replace(/\s+/g, ' ').trim().toLocaleLowerCase('pt-BR');

      if (linkLabel === targetLabel) {
        link.classList.add('kyron-club-menu-link');
      }
    });
  };

  enhanceKyronClubMenu();

  document.addEventListener('shopify:section:load', (event) => {
    enhanceKyronClubMenu(event.target);
  });
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kyron-club-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!window.kyronComparisonScrollReady) {
    window.kyronComparisonScrollReady = true;

    const triggerSelector = '[data-kyron-scroll-to-simulator]';
    const simulatorSelector = '.kyron-club-simulator';

    const findSimulator = () => document.querySelector(simulatorSelector);

    const connectTriggers = (root = document) => {
      const simulator = findSimulator();

      if (!simulator) return;

      root.querySelectorAll(triggerSelector).forEach((trigger) => {
        if (simulator.id) trigger.setAttribute('href', `#${simulator.id}`);
      });
    };

    const initialize = () => connectTriggers(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => {
      connectTriggers(event.target);
    });

    document.addEventListener('click', (event) => {
      const trigger = event.target instanceof Element
        ? event.target.closest(triggerSelector)
        : null;

      if (!trigger) return;

      const simulator = findSimulator();

      if (!simulator) return;

      event.preventDefault();

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      simulator.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kyron-club-discount-simulator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('kyron-club-simulator')) {
    customElements.define('kyron-club-simulator', class extends HTMLElement {
      connectedCallback() {
    const section = this;
    if (!section || section.dataset.simulatorReady === 'true') return;

    section.dataset.simulatorReady = 'true';

    const productButtons = Array.from(section.querySelectorAll('[data-product-option]'));
    const catalogGroups = section.querySelector('[data-catalog-groups]');
    const productSearch = section.querySelector('[data-product-search]');
    const noResults = section.querySelector('[data-no-results]');
    const frequencyInputs = section.querySelectorAll('.kyron-club-simulator__frequency-input');
    const selectedList = section.querySelector('[data-selected-list]');
    const emptySelection = section.querySelector('[data-empty-selection]');
    const itemCount = section.querySelector('[data-item-count]');
    const productImage = section.querySelector('[data-product-image]');
    const productPlaceholder = section.querySelector('[data-product-placeholder]');
    const productCaption = section.querySelector('[data-product-caption]');
    const regularPrice = section.querySelector('[data-regular-price]');
    const discountValue = section.querySelector('[data-discount-value]');
    const subscriptionPrice = section.querySelector('[data-subscription-price]');
    const savings = section.querySelector('[data-savings]');
    const feedback = section.querySelector('[data-feedback]');
    const addToCartButton = section.querySelector('[data-add-to-cart]');
    const ctaLabel = section.querySelector('[data-cta-label]');
    const defaultCtaCopy = ctaLabel.textContent;
    const loadingCtaCopy = section.dataset.loadingCopy || 'ADICIONANDO AO CARRINHO...';
    const placeholderCopy = section.dataset.placeholderCopy || productCaption.textContent.trim();
    const currency = section.dataset.currency || 'BRL';
    const locale = section.dataset.locale || 'pt-BR';
    const formatter = new Intl.NumberFormat(locale, { style: 'currency', currency });
    const selection = new Map();
    const productPlanCache = new Map();
    const routesRoot = window.Shopify?.routes?.root || '/';
    const cartJsonUrl = `${routesRoot}cart.js`;
    const cartChangeUrl = `${routesRoot}cart/change.js`;

    const escapeHtml = (value) => String(value).replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    })[character]);

    const formatMoney = (cents) => formatter.format(cents / 100);
    const normalize = (value) => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

    const currentFrequency = () => {
      const input = section.querySelector('.kyron-club-simulator__frequency-input:checked');
      return {
        days: input?.value || '30',
        discount: Number(input?.dataset.discountRate || 10)
      };
    };

    const planFor = (item, days) => item.plans[days] || { id: '', price: 0 };

    const planFrequency = (descriptor, discount) => {
      if (
        descriptor.includes('bimestral') ||
        descriptor.includes('bimonthly') ||
        descriptor.includes('60 dia') ||
        descriptor.includes('2 mes') ||
        descriptor.includes('2 month')
      ) return '60';

      if (
        descriptor.includes('mensal') ||
        descriptor.includes('monthly') ||
        descriptor.includes('30 dia') ||
        descriptor.includes('1 mes') ||
        descriptor.includes('1 month')
      ) return '30';

      if (discount === 10) return '30';
      if (discount === 5) return '60';
      return '';
    };

    const plansFromProductJson = (productData, variantId) => {
      const result = {
        30: { id: '', price: 0 },
        60: { id: '', price: 0 }
      };
      const variant = (productData.variants || []).find((entry) => String(entry.id) === String(variantId));
      const groups = productData.selling_plan_groups || [];
      const sellingPlans = groups.flatMap((group) => group.selling_plans || []);
      const plansById = new Map(sellingPlans.map((plan) => [String(plan.id), plan]));
      const allocations = variant?.selling_plan_allocations || [];

      allocations.forEach((allocation) => {
        const id = String(allocation.selling_plan_id || '');
        const plan = plansById.get(id);
        const optionValues = (plan?.options || []).map((option) => option.value || '').join(' ');
        const descriptor = normalize(`${plan?.name || ''} ${optionValues}`);
        const compareAtPrice = Number(allocation.compare_at_price || variant?.price || 0);
        const allocationPrice = Number(allocation.price || 0);
        const discount = compareAtPrice > 0
          ? Math.round((compareAtPrice - allocationPrice) * 100 / compareAtPrice)
          : 0;
        const frequency = planFrequency(descriptor, discount);

        if (frequency && !result[frequency].id) {
          result[frequency] = { id, price: allocationPrice };
        }
      });

      if (!allocations.length) {
        sellingPlans.forEach((plan) => {
          const optionValues = (plan.options || []).map((option) => option.value || '').join(' ');
          const descriptor = normalize(`${plan.name || ''} ${optionValues}`);
          const frequency = planFrequency(descriptor, 0);
          if (frequency && !result[frequency].id) {
            result[frequency] = { id: String(plan.id), price: 0 };
          }
        });
      }

      if (allocations.length === 2) {
        const sortedAllocations = [...allocations].sort((first, second) => Number(first.price) - Number(second.price));
        if (!result[30].id) {
          result[30] = {
            id: String(sortedAllocations[0].selling_plan_id),
            price: Number(sortedAllocations[0].price || 0)
          };
        }
        if (!result[60].id) {
          result[60] = {
            id: String(sortedAllocations[1].selling_plan_id),
            price: Number(sortedAllocations[1].price || 0)
          };
        }
      }

      return result;
    };

    const hydrateItemPlans = async (item) => {
      if (item.plans[30].id && item.plans[60].id) return item;

      if (!productPlanCache.has(item.productJsonUrl)) {
        productPlanCache.set(
          item.productJsonUrl,
          fetch(item.productJsonUrl, { headers: { Accept: 'application/json' } }).then((response) => {
            if (!response.ok) throw new Error(section.dataset.cartErrorCopy);
            return response.json();
          })
        );
      }

      const productData = await productPlanCache.get(item.productJsonUrl);
      const remotePlans = plansFromProductJson(productData, item.variantId);

      if (remotePlans[30].id) item.plans[30] = remotePlans[30];
      if (remotePlans[60].id) item.plans[60] = remotePlans[60];
      return item;
    };

    const buildCatalog = () => {
      const categories = new Map();

      productButtons.forEach((button) => {
        const category = button.dataset.category;
        if (!categories.has(category)) categories.set(category, []);
        categories.get(category).push(button);
      });

      catalogGroups.replaceChildren();

      Array.from(categories.entries()).forEach(([category, buttons], index) => {
        const details = document.createElement('details');
        details.className = 'kyron-club-simulator__catalog-group';
        if (index === 0) details.open = true;

        const summary = document.createElement('summary');
        summary.className = 'kyron-club-simulator__catalog-summary';
        summary.textContent = category;

        const items = document.createElement('div');
        items.className = 'kyron-club-simulator__catalog-items';
        buttons.forEach((button) => items.appendChild(button));

        details.append(summary, items);
        catalogGroups.appendChild(details);
      });
    };

    const productFromButton = (button) => ({
      variantId: button.dataset.variantId,
      productJsonUrl: button.dataset.productJsonUrl,
      title: button.dataset.title,
      price: Number(button.dataset.price || 0),
      image: button.dataset.imageSrc || '',
      imageAlt: button.dataset.imageAlt || button.dataset.title,
      quantity: 1,
      plans: {
        30: {
          id: button.dataset.plan30Id || '',
          price: Number(button.dataset.plan30Price || 0)
        },
        60: {
          id: button.dataset.plan60Id || '',
          price: Number(button.dataset.plan60Price || 0)
        }
      }
    });

    const updateProductMedia = (item) => {
      if (item?.image) {
        productImage.src = item.image;
        productImage.alt = item.imageAlt;
        productImage.hidden = false;
        productPlaceholder.hidden = true;
        productCaption.textContent = item.title;
      } else if (selection.size === 0) {
        productImage.removeAttribute('src');
        productImage.alt = '';
        productImage.hidden = true;
        productPlaceholder.hidden = false;
        productCaption.textContent = placeholderCopy;
      }
    };

    const renderSelection = () => {
      const { days, discount } = currentFrequency();
      let regularTotal = 0;
      let clubTotal = 0;
      let totalQuantity = 0;

      selectedList.replaceChildren();

      selection.forEach((item) => {
        const plan = planFor(item, days);
        const calculatedUnitPrice = Math.round(item.price * (100 - discount) / 100);
        const clubUnitPrice = plan.price || calculatedUnitPrice;
        regularTotal += item.price * item.quantity;
        clubTotal += clubUnitPrice * item.quantity;
        totalQuantity += item.quantity;

        const row = document.createElement('div');
        row.className = 'kyron-club-simulator__selected-item';
        row.dataset.variantId = item.variantId;
        const imageMarkup = item.image
          ? `<img class="kyron-club-simulator__selected-thumb" src="${escapeHtml(item.image)}" alt="" width="84" height="84" loading="lazy">`
          : '<span class="kyron-club-simulator__selected-thumb"></span>';
        const planMarkup = plan.id
          ? `<span>${escapeHtml(formatMoney(clubUnitPrice))}</span>`
          : `<span class="kyron-club-simulator__plan-warning">${escapeHtml(section.dataset.planUnavailableCopy)}</span>`;

        row.innerHTML = `
          ${imageMarkup}
          <div class="kyron-club-simulator__selected-copy">
            <span class="kyron-club-simulator__selected-title">${escapeHtml(item.title)}</span>
            <span class="kyron-club-simulator__selected-meta">${planMarkup}</span>
          </div>
          <div class="kyron-club-simulator__item-controls">
            <div class="kyron-club-simulator__quantity">
              <button class="kyron-club-simulator__quantity-button" type="button" data-quantity-action="decrease" aria-label="${escapeHtml(section.dataset.quantityCopy)}: ${escapeHtml(item.title)}">−</button>
              <input class="kyron-club-simulator__quantity-input" type="number" min="1" max="99" value="${item.quantity}" data-quantity-input aria-label="${escapeHtml(section.dataset.quantityCopy)}: ${escapeHtml(item.title)}">
              <button class="kyron-club-simulator__quantity-button" type="button" data-quantity-action="increase" aria-label="${escapeHtml(section.dataset.quantityCopy)}: ${escapeHtml(item.title)}">+</button>
            </div>
            <button class="kyron-club-simulator__remove-button" type="button" data-remove-item aria-label="${escapeHtml(section.dataset.removeCopy)}: ${escapeHtml(item.title)}">×</button>
          </div>`;
        selectedList.appendChild(row);
      });

      const hasItems = selection.size > 0;
      emptySelection.hidden = hasItems;
      addToCartButton.disabled = !hasItems;
      itemCount.textContent = String(totalQuantity);
      discountValue.textContent = `${discount}%`;
      regularPrice.textContent = hasItems ? formatMoney(regularTotal) : '—';
      subscriptionPrice.textContent = hasItems ? formatMoney(clubTotal) : '—';
      savings.textContent = hasItems ? formatMoney(regularTotal - clubTotal) : '—';
      feedback.textContent = '';
    };

    const addProduct = (button) => {
      const item = productFromButton(button);
      const existing = selection.get(item.variantId);

      if (existing) {
        item.quantity = Math.min(existing.quantity + 1, 99);
        if (existing.plans[30].id) item.plans[30] = existing.plans[30];
        if (existing.plans[60].id) item.plans[60] = existing.plans[60];
      }

      selection.set(item.variantId, item);
      updateProductMedia(item);
      renderSelection();

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      hydrateItemPlans(item)
        .then((hydratedItem) => {
          const selectedItem = selection.get(hydratedItem.variantId);
          if (!selectedItem) return;
          selectedItem.plans = hydratedItem.plans;
          renderSelection();
        })
        .catch(() => {
          productPlanCache.delete(item.productJsonUrl);
        })
        .finally(() => {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        });
    };

    const updateQuantity = (variantId, quantity) => {
      const item = selection.get(variantId);
      if (!item) return;
      item.quantity = Math.min(Math.max(Number(quantity) || 1, 1), 99);
      renderSelection();
    };

    const requestTokenFromLine = (line) => String(line?.properties?._kyron_club_token || '');

    const sellingPlanIdFromLine = (line) => String(
      line?.selling_plan_allocation?.selling_plan?.id ||
      line?.selling_plan_allocation?.selling_plan_id ||
      ''
    );

    const lineHasExpectedPlan = (line, expectedItem) => (
      requestTokenFromLine(line) === expectedItem.token &&
      sellingPlanIdFromLine(line) === expectedItem.sellingPlanId
    );

    const fetchCart = async () => {
      const response = await fetch(cartJsonUrl, { headers: { Accept: 'application/json' } });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message || section.dataset.cartErrorCopy);
      return cart;
    };

    const changeCartLine = async (line, quantity, sellingPlanId) => {
      const response = await fetch(cartChangeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          line,
          quantity,
          selling_plan: sellingPlanId ? Number(sellingPlanId) : null
        })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || cart.message || section.dataset.cartErrorCopy);
      return cart;
    };

    const confirmSellingPlans = async (expectedItems, addResult) => {
      const addedLines = Array.isArray(addResult?.items) ? addResult.items : [];
      const responseConfirmedEveryPlan = expectedItems.every((expectedItem) => (
        addedLines.some((line) => lineHasExpectedPlan(line, expectedItem))
      ));

      if (responseConfirmedEveryPlan) return;

      for (const expectedItem of expectedItems) {
        let cart = await fetchCart();
        let lineIndex = cart.items.findIndex((line) => requestTokenFromLine(line) === expectedItem.token);
        if (lineIndex < 0) throw new Error(section.dataset.planApplyErrorCopy);

        if (!lineHasExpectedPlan(cart.items[lineIndex], expectedItem)) {
          cart = await changeCartLine(lineIndex + 1, cart.items[lineIndex].quantity, expectedItem.sellingPlanId);
          lineIndex = cart.items.findIndex((line) => requestTokenFromLine(line) === expectedItem.token);
          if (lineIndex < 0 || !lineHasExpectedPlan(cart.items[lineIndex], expectedItem)) {
            throw new Error(section.dataset.planApplyErrorCopy);
          }
        }
      }
    };

    const removeRequestItems = async (expectedItems) => {
      const pendingTokens = new Set(expectedItems.map((item) => item.token));

      while (pendingTokens.size) {
        const cart = await fetchCart();
        const lineIndex = cart.items.findIndex((line) => pendingTokens.has(requestTokenFromLine(line)));
        if (lineIndex < 0) break;
        pendingTokens.delete(requestTokenFromLine(cart.items[lineIndex]));
        await changeCartLine(lineIndex + 1, 0, '');
      }
    };

    buildCatalog();
    noResults.hidden = productButtons.length > 0;

    productButtons.forEach((button) => button.addEventListener('click', () => addProduct(button)));

    productSearch.addEventListener('input', () => {
      const query = normalize(productSearch.value.trim());
      let visibleCount = 0;

      productButtons.forEach((button) => {
        const matches = !query || normalize(`${button.dataset.title} ${button.dataset.category}`).includes(query);
        button.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      section.querySelectorAll('.kyron-club-simulator__catalog-group').forEach((group) => {
        const hasVisibleProduct = Array.from(group.querySelectorAll('[data-product-option]')).some((button) => !button.hidden);
        group.hidden = !hasVisibleProduct;
        if (query && hasVisibleProduct) group.open = true;
      });

      noResults.hidden = visibleCount > 0;
    });

    frequencyInputs.forEach((input) => input.addEventListener('change', renderSelection));

    selectedList.addEventListener('click', (event) => {
      const row = event.target.closest('[data-variant-id]');
      if (!row) return;
      const variantId = row.dataset.variantId;

      if (event.target.closest('[data-remove-item]')) {
        selection.delete(variantId);
        renderSelection();
        updateProductMedia(Array.from(selection.values()).at(-1));
        return;
      }

      const action = event.target.closest('[data-quantity-action]')?.dataset.quantityAction;
      const item = selection.get(variantId);
      if (!action || !item) return;
      updateQuantity(variantId, item.quantity + (action === 'increase' ? 1 : -1));
    });

    selectedList.addEventListener('change', (event) => {
      if (!event.target.matches('[data-quantity-input]')) return;
      const row = event.target.closest('[data-variant-id]');
      if (row) updateQuantity(row.dataset.variantId, event.target.value);
    });

    addToCartButton.addEventListener('click', async () => {
      const { days } = currentFrequency();
      const selectedItems = Array.from(selection.values());
      const missingPlans = selectedItems.filter((item) => !planFor(item, days).id);
      let requestItems = [];

      if (missingPlans.length) {
        feedback.textContent = `${section.dataset.missingPlanCopy} ${missingPlans.map((item) => item.title).join(', ')}.`;
        return;
      }

      const requestId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      requestItems = selectedItems.map((item, index) => {
        const sellingPlanId = String(planFor(item, days).id);
        const token = `${requestId}-${index}`;

        return {
          token,
          sellingPlanId,
          cartItem: {
            id: Number(item.variantId),
            quantity: item.quantity,
            selling_plan: Number(sellingPlanId),
            properties: {
              [section.dataset.cartFrequencyProperty]: `${days} dias`,
              _kyron_club_token: token
            }
          }
        };
      });

      addToCartButton.disabled = true;
      ctaLabel.textContent = loadingCtaCopy;
      feedback.textContent = '';

      try {
        const response = await fetch(section.dataset.cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: requestItems.map((item) => item.cartItem) })
        });
        const result = await response.json();

        if (!response.ok) throw new Error(result.description || result.message || section.dataset.cartErrorCopy);
        await confirmSellingPlans(requestItems, result);
        window.location.href = section.dataset.cartUrl;
      } catch (error) {
        if (requestItems.length) {
          try {
            await removeRequestItems(requestItems);
          } catch (cleanupError) {
          }
        }
        feedback.textContent = error.message || section.dataset.cartErrorCopy;
        addToCartButton.disabled = false;
        ctaLabel.textContent = defaultCtaCopy;
      }
    });

    renderSelection();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
